import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '../assets/toast.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#1a2b59',
        secondary: '#fff',
        tertiary: '#799495',
        background: '#e4e4e4',
        vor: '#00959f',
      },
      dark: {
        primary: '#1a2b59',
        secondary: '#424242',
        tertiary: '#799495',
        background: '#000',
        vor: '#00959f',
      },
    },
  },
};

export default new Vuetify(opts);
